/**
 * ErrorRostro.js
 * @author Jaiván Piña
 */ 

//Dependencies
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux'
import $ from 'jquery';
import { onBoardingDigital } from '../../../actions/actions'

//material-ui
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

// Components
import Legal from '../Legal';

//Assets
import warning from '../../../static/img/warning.png';

//Services
import { processIdClientAnalytics } from './../services/pixelService';
import { Layout } from '../layout/Layout';

class ErrorRostro extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.goBack = this.goBack.bind(this);
    }

    componentDidMount() {
        $(".load").fadeOut(700);
    }

    componentWillMount() {
        processIdClientAnalytics('error-rostro');
    }

    goBack() {
        $(".load").fadeIn(700);
        this.props.history.goBack();
    }

    render() {
        const footer = {
            button: {
                action : this.goBack,
                text : "reintentar"
            }
        };
        const body = { img : { src : warning } }
        return (
            <Layout footer={footer} body={body}
                tieneFooter>
                <Grid container
                    direction="row"
                    justify="center"
                    alignItems="center">
                    <Grid item xs={12}>
                        <div className="content-description">
                            <h5 className="title" >Ups… algo falló</h5>
                            <ul>
                                <li> <span></span>Asegurate de que haya suficiente luz.</li>
                                <li><span></span>No olvides hacer los gestos que figuran en pantalla.</li>
                                <li><span></span>Asegurate ubicar tu cara dentro del marco.</li>
                            </ul>
                        </div>
                    </Grid>
                </Grid>
            </Layout>
        );
    }
}

const mapStateToProps = function (state) {
    return {
        estado: state,
    }
}

export default connect(mapStateToProps)(ErrorRostro);


// WEBPACK FOOTER //
// ./src/components/OnBoarding/error/ErrorRostro.js